export class ActionTypes
{
    public static TUNE = "tune";
    public static CREATE_SEEDED = "createSeeded";
}
